export default __webpack_public_path__ + "static/media/Wall_Conveyor_x2_Orange.256.91a130a9.png";